import { render, staticRenderFns } from "./detailPage.html?vue&type=template&id=425f9902&scoped=true&"
import script from "./detailPage.js?vue&type=script&lang=js&"
export * from "./detailPage.js?vue&type=script&lang=js&"
import style0 from "./detailPage.styl?vue&type=style&index=0&id=425f9902&lang=styl&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "425f9902",
  null
  
)

export default component.exports